<template>
  <div class="tree-node">
    <div class="tree-row">
      <!-- Toggle Icon -->
      <div class="toggle-icon" @click="isOpen = !isOpen">
        <i
          v-if="item.children && item.children.length"
          :class="isOpen ? 'bi bi-chevron-down' : 'bi bi-chevron-left'"
        ></i>
        <i v-else class="bi bi-dot"></i>
      </div>

      <!-- Title -->
      <div class="category-info">
        <i class="bi bi-folder2-open text-primary me-2"></i>
        <span class="category-title">{{ item.title }}</span>
      </div>

      <!-- Actions -->
      <div class="actions">
       
          <button class="btn-action add" :title="currentLang.btnAdd"
          @click="emit('add-child', props.item)">
    <i class="bi bi-plus"></i>
  </button>

  <button class="btn-action edit" :title="currentLang.btnEdit"
          @click="emit('edit', props.item)">
    <i class="bi bi-pencil"></i>
  </button>

        <button class="btn-action delete" :title="currentLang.btnDelete" @click="handleDelete">
          <i class="bi bi-trash"></i>
        </button>
      </div>
    </div>

   

    <div v-if="isOpen && item.children && item.children.length" class="children-wrapper">
  <CategoryItem 
    v-for="child in item.children" 
    :key="child.id" 
    :item="child" 
    @refresh="$emit('refresh')"
    @edit="$emit('edit', $event)"
    @add-child="$emit('add-child', $event)"
  />
  </div>
  </div>
</template>

<script setup>
import { ref,computed } from "vue";
import api from "@/plugins/axios";
import { alertStore } from "@/stores/alertStore";

import { lang } from "@/plugins/lang";
import enText from "@/locales/en/CategoryTreeItem";
import faText from "@/locales/fa/CategoryTreeItem";

const translations = {
  en: enText,
  fa: faText,
};
const currentLang = computed(() => translations[lang.value]);





/* eslint-disable no-undef */
const emit = defineEmits(["refresh", "edit", "add-child"]);

defineOptions({
  name: "CategoryItem",
});

// فقط یک بار صدا بزنید
const props = defineProps({
  item: { type: Object, required: true },
});
/* eslint-enable no-undef */
const isOpen = ref(true);

const handleDelete = async () => {
  if (!confirm(`حذف "${props.item.title}" ؟`)) return;

  try {
    const response = await api.delete(`/admin/categories/${props.item.id}`);

    if (response.status === 200) {
      alertStore.trigger("success",currentLang.value.success, currentLang.value.deleted);
      emit("refresh");
    }
  } catch (e) {
    alert(currentLang.value.error);
  }
};
</script>


<style scoped>
.tree-node {
  margin-top: 4px;
}

.tree-row {
  display: flex;
  align-items: center;
  padding: 10px 15px;
  background: #fdfdfd;
  border: 1px solid #f1f1f1;
  border-radius: 10px;
  transition: 0.2s;
}

.tree-row:hover {
  background: #f8fafc;
  border-color: #e2e8f0;
}

.toggle-icon {
  width: 25px;
  cursor: pointer;
  color: #64748b;
}

.category-info {
  flex-grow: 1;
  font-weight: 500;
  color: #1e293b;
}

.children-wrapper {
  margin-right: 25px; /* ایجاد فاصله برای زیرمجموعه‌ها در RTL */
  border-right: 1px dashed #cbd5e1;
  padding-right: 10px;
}

.actions {
  display: flex;
  gap: 8px;
}

.btn-action {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: 0.2s;
}

.btn-action.add {
  background: #f0fdf4;
  color: #16a34a;
}
.btn-action.edit {
  background: #eff6ff;
  color: #2563eb;
}
.btn-action.delete {
  background: #fef2f2;
  color: #dc2626;
}

.btn-action:hover {
  transform: scale(1.1);
}

/* استایل نمونه برای مدال؛ اگر Bootstrap Modal استفاده می‌کنی، می‌تونی این بخش رو حذف کنی */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  min-width: 320px;
  max-width: 420px;
}
</style>
